function required(key: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing env: ${key}`);
  }
  return value;
}

export const env = {
  SUPABASE_URL: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  SUPABASE_ANON_KEY: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  SUBSCRIPTION_TOSS_CLIENT_KEY:
    import.meta.env.VITE_SUBSCRIPTION_TOSS_CLIENT_KEY ?? '',
  APP_ORIGIN:
    import.meta.env.VITE_APP_ORIGIN ?? window.location.origin,
};
